
import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import { environment } from 'environments/environment';
import { fuelUsers } from './fuelUsers.model';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import {GridDataResult,DataStateChangeEvent} from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs/Observable'; 
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { fuelLocation } from './fuelUsers.model';

declare var $: any;

@Component({
    selector: 'fuel-user',
    templateUrl: './fuelUser.component.html',
})

export class FuelUserComponent {
  setPermsSuccess: any
  search: any
  showLoader: any;
  fuelMobileUserList: any;
  fuelRecardStatus = false;
  fuelUserDoc: AngularFirestoreDocument<fuelUsers>;
  loading: boolean = true;
  fuelUsersItems:any;
  firebaseData: any;
  ggnCheck: boolean;
  lkoCheck: boolean;
  fbdCheck: boolean;
  gwlCheck: boolean;
  name: any;
  mobile: any;
  vehMaintDoc: AngularFirestoreDocument<fuelLocation>;

  public state: State = { 
    skip: 0,
    take: 15,  
    filter: { 
      logic: 'and',
      filters: []
    }
  };
  public gridDataCouponCollection: GridDataResult
  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  prjList: { id: number; prjname: string; }[];
  prjId: any;
  userName: any;
  locationName: any;
  prjName: any;
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }
  private loadProducts(): void {
    this.gridDataUserList = process(this.fuelMobileUserList, { group: this.groups }); 
  }
  public gridDataUserList: GridDataResult  
  public allData(): ExcelExportData {
  const result: ExcelExportData =  {
      data: this.fuelMobileUserList
  };
  return result;
  }
  
  constructor(private http: HttpClient, public afs: AngularFirestore, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
      this.allData = this.allData.bind(this);
    });
    $("#save-loader").hide()
  }

  /*
    * GET UCC RECEIPT REPORT 
    */
  getFuelUserReport() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'uccnew/fuelUsersList').subscribe(data => {
      this.fuelMobileUserList = data;
      if (this.fuelMobileUserList.length > 0) {
        this.loaderService.display(false);
        this.fuelRecardStatus = false;
        for (let i = 0; i < this.fuelMobileUserList.length; i++) {
          let arr = this.fuelMobileUserList[i].Permission_Json
          this.fuelMobileUserList[i].prj = ''
          this.fuelMobileUserList[i].hasPerms = false
          if (arr) {
            if (arr.LUCKNOW.active) {
              this.fuelMobileUserList[i].prj += ', ' +  'LUCKNOW'
            }
            if (arr.GURUGRAM.active){
              this.fuelMobileUserList[i].prj += ', ' + 'GURUGRAM'
            }
            if (arr.FARIDABAD.active){
              this.fuelMobileUserList[i].prj += ', ' +  'FARIDABAD'
            }
            if (arr.GWALIOR.active){
              this.fuelMobileUserList[i].prj += ', ' +  'GWALIOR'
            }
            if (!arr.LUCKNOW.active && !arr.GURUGRAM.active && !arr.FARIDABAD.active && !arr.GWALIOR.active){
              this.fuelMobileUserList[i].prj = 'N/A'
            }
            // this.fuelMobileUserList[i].prj = arr.FARIDABAD.active ? 'FARIDABAD' : arr.GURUGRAM.active ? 'GURUGRAM' : arr.LUCKNOW.active ? 'LUCKNOW' : arr.GWALIOR.active ? 'GWALIOR' : 'N/A';  
            this.fuelMobileUserList[i].prj = (this.fuelMobileUserList[i].prj != 'N/A') ? this.fuelMobileUserList[i].prj.substring(2) : this.fuelMobileUserList[i].prj
            this.fuelMobileUserList[i].hasPerms = (arr.FARIDABAD.active || arr.GURUGRAM.active ||  arr.LUCKNOW.active || arr.GWALIOR.
              active) ? true : false;  
          } else {
            console.log(i);
            this.fuelMobileUserList.splice(i, 1);
          }
        }
        this.gridDataUserList = process(this.fuelMobileUserList, this.state); 
      } else {
        this.fuelRecardStatus = true;
        this.loaderService.display(false);
        this.gridDataUserList = process(this.fuelMobileUserList, this.state); 
      }
    });
  }

  public dataStateChange(state: DataStateChangeEvent): void { 
    this.state = state;
    this.gridDataUserList = process(this.fuelMobileUserList, this.state); 
    if (state && state.group) {   
      this.gridDataUserList = process(this.fuelMobileUserList, this.state); 
    } 
  }

  clearFields() {
    this.setPermsSuccess = false
    // this.firebaseData = {}
    this.name = null
    this.mobile = null
  }

  /*
  * View and Edit Permission
  */
  setPermission(userData) {
    this.clearFields()
    this.getCollection(userData).subscribe(items => {
      this.firebaseData = items[0];
    })
    console.log(this.firebaseData);
    this.name = this.firebaseData.name
    this.mobile = this.firebaseData.mobile

    this.fbdCheck = this.firebaseData.Permission_Json.FARIDABAD.active
    this.ggnCheck = this.firebaseData.Permission_Json.GURUGRAM.active
    this.lkoCheck = this.firebaseData.Permission_Json.LUCKNOW.active
    this.gwlCheck = this.firebaseData.Permission_Json.GWALIOR.active
    $("#updatePermissionModal").modal("show");
  }

  /*
  * Set Location
  */
  setLocation(userData) {
    this.clearFields()
    this.mobile = userData.mobile
    this.userName = userData.name
    console.log(this.mobile);
    $("#setLocationModal").modal("show");
  }

  prjSelector(data){
    this.prjId = data.value
    this.prjName = this.prjList.find(x => x.id === data.value).prjname
  }

  addLocation(){
    console.log(this.locationName);
    
    var card = [{
      card_number: "''",
      projectID: this.prjId
    }]
    var location = [{
      name: this.locationName,
      projectID: this.prjId
    }]
    var data = {
      Location_Card_Permission: {
        card: card,
        location: location
      },
      mobile : this.mobile,
      name : this.userName
    }
    this.vehMaintDoc = this.afs.collection("LOCATION_CARD")
    .doc(this.mobile);
    // this.vehMaintDoc.set(data)
    console.log(data);
    
  }

  getCollection(userData){
    this.fuelUsersItems = this.afs.collection('Users', ref => ref
    .where('mobile', '==', userData.mobile))
    .valueChanges();
    return this.fuelUsersItems
  }

  updatePerms(){
    let fbd = this.firebaseData.Permission_Json.FARIDABAD
    let ggn = this.firebaseData.Permission_Json.GURUGRAM
    let lko = this.firebaseData.Permission_Json.LUCKNOW
    let gwl = this.firebaseData.Permission_Json.GWALIOR

    // fbd
    fbd.active = this.fbdCheck
    fbd.permissions.fuel.active = this.fbdCheck
    fbd.permissions.fuel.create.active = this.fbdCheck
    fbd.permissions.fuel.edit.active = this.fbdCheck
    fbd.permissions.fuel.list.active = this.fbdCheck
    
    // ggn
    ggn.active = this.ggnCheck
    ggn.permissions.fuel.active = this.ggnCheck
    ggn.permissions.fuel.create.active = this.ggnCheck
    ggn.permissions.fuel.edit.active = this.ggnCheck
    ggn.permissions.fuel.list.active = this.ggnCheck
    
    // lkofuelUser
    lko.active = this.lkoCheck
    lko.permissions.fuel.active = this.lkoCheck
    lko.permissions.fuel.create.active = this.lkoCheck
    lko.permissions.fuel.edit.active = this.lkoCheck
    lko.permissions.fuel.list.active = this.lkoCheck
    
    // gwl
    gwl.active = this.gwlCheck
    gwl.permissions.fuel.active = this.gwlCheck
    gwl.permissions.fuel.create.active = this.gwlCheck
    gwl.permissions.fuel.edit.active = this.gwlCheck
    gwl.permissions.fuel.list.active = this.gwlCheck

    this.fuelUserDoc = this.afs.collection('Users').doc(this.mobile);
    console.log(this.firebaseData);
    this.fuelUserDoc.update(this.firebaseData)
    setTimeout(() => {
      this.setPermsSuccess = true
      this.getFuelUserReport()
      $("#updatePermissionModal").modal("show");
    }, 1500); 
  }

  ngOnInit() {
    this.getFuelUserReport();
    this.prjList = [
      {id : 1, prjname : 'Lucknow'},
      {id : 2, prjname : 'Gurugram'},
      {id : 3, prjname : 'Faridabad'}
    ]
  }
}


// WEBPACK FOOTER //
// ./src/app/superAdmin/users/fuelUser.component.ts